// F-63c: the header's action buttons live in two places depending on the width: the Lock and "Create homework" buttons sit inline
// in the header from 768px up and fold into the overflow menu below it. The editor is built once per note, so when the window is
// resized across 768 with the note open (iPhone rotation, iPad Slide Over / Split View, a dragged desktop window) the buttons must
// MOVE, not the sheet be rebuilt (a rebuild re-attaches the live editor and drops the focus and the iPad caret, F-53).
// Duck-typed on purpose (parentNode / removeChild / insertBefore / appendChild), so it runs under plain node in the tests.
//   o.phone         true when the width is under 768
//   o.hactions      the header actions element
//   o.lockBtn, o.hwBtn   the two movable buttons (either may be null; one that was dropped, e.g. on lock, is in neither place and stays gone)
//   o.menuItems     the overflow menu's item array (mutated in place; the Delete item stays last)
//   o.getOverflow   () => the overflow button or null
//   o.closeMenu     () => void   (an open menu holds its buttons detached from the header)
//   o.syncOverflow  () => void   (creates / re-attaches / removes the overflow button to match menuItems)
export function reslotHeaderActions(o) {
  o.closeMenu();
  const movers = [o.lockBtn, o.hwBtn].filter(Boolean);
  const inHeader = b => b.parentNode === o.hactions;
  const inMenu = b => o.menuItems.indexOf(b) >= 0;
  if (o.phone) {
    const live = movers.filter(b => inHeader(b) || inMenu(b));
    live.forEach(b => { if (inHeader(b)) o.hactions.removeChild(b); });
    const rest = o.menuItems.filter(x => movers.indexOf(x) < 0);
    o.menuItems.splice(0, o.menuItems.length, ...live, ...rest);
  } else {
    const fold = movers.filter(inMenu);
    fold.forEach(b => o.menuItems.splice(o.menuItems.indexOf(b), 1));
    const ov = o.getOverflow();
    fold.forEach(b => { if (ov && ov.parentNode === o.hactions) o.hactions.insertBefore(b, ov); else o.hactions.appendChild(b); });
  }
  o.syncOverflow();
}
